import moment from 'moment';
import React from 'react';
import { Link } from 'react-router-dom';
import StatusBadge from '../../Components/StatusBadge/StatusBadge';
import Table from '../../Components/Table/Table';

const statusList = {
  Commerce : '커머스 쿠폰',
  Normal : '일반 쿠폰',
}

const variant = {
  Commerce : 'primary',
  Normal : 'success',
}

const CouponHistory = () => {
    const modalRef = React.useRef(null);
    const [ data, setData ] = React.useState({});
    
    const columnsCoupon = React.useMemo(
        () => [
          {
            /* Header: '쿠폰이름을을 검색해보세요.', */
            Header: '쿠폰이름',
            accessor: 'Coupon.Name', // accessor is the "key" in the data
            disableSortBy : true,
            Cell : (props) => {
              return (
                <p className='table-title'>{props.cell.value}</p>
              )
            },
            width : 260,
            minWidth : 260
          },
          {
            /* Header: '쿠폰혜택을 검색해보세요.', */
            Header: '쿠폰혜택',
            accessor: 'Coupon.Description',
            disableSortBy : true,
            minWidth : 260,
            width : 260,
            Cell : (props) => {
                return(
                    <p>{props.cell.value}</p>
                )
            }
          },
          {
            Header: '사용일시',
            accessor: 'Date.$date',
            disableFilters : true,
            minWidth : 130,
            width : 130,
            Cell : (props) => {
              return(
                  <p>{moment(props.cell.value).utc().locale('ko').format('YY-MM-DD(dd) HH:mm')}</p>
              )
            }
          },
          {
            Header: '유저번호',
            accessor: 'UserInfo',
            disableSortBy : true,
            minWidth : 130,
            width : 130,
            Cell : (props) => {
              if(typeof props.cell.value !== 'undefined'){
                return(
                  <Link to={ `/user-info/${props.cell.value._id.$oid}`}>
                    <p style={{ color : '#f95f53' }}>{ (typeof props.cell.value === 'undefined') ? '탈퇴한 회원' : props.cell.value.Tel}</p>
                  </Link>
                )
              }else {
                return(
                  <p style={{ color : '#f95f53' }}>{ (typeof props.cell.value === 'undefined') ? '탈퇴한 회원' : props.cell.value.Tel}</p>
                )
              }
            }
          },
          {
            Header: '상태',
            accessor: 'Channel',
            disableFilters : true,
            isDropdown : true,
            options : [
              { key : 'test1' , value : 'Ccc11'},
              { key : 'test2' , value : '22'},
              { key : 'test3' , value : '33'},
              { key : 'test4' , value : '44'},
            ],
            Cell : (props) => {
                return(
                    <StatusBadge Status={statusList[(typeof props.cell.value !== 'undefined' && props.cell.value === 'Commerce') ? 'Commerce' : 'Normal']} variant={variant[(typeof props.cell.value !== 'undefined' && props.cell.value === 'Commerce') ? 'Commerce' : 'Normal']}/>
                )
            },
            minWidth : 110,
            width : 110
          }
        ]
    )

    return (
        <div>
            <Table columns={columnsCoupon} url={'/api/history/coupon'}/>
        </div>
    )
}

export default CouponHistory;